// validationSchema.ts
import * as yup from "yup";

export const groupPermissionsSchema = yup.object().shape({
  nome: yup.string().required("O nome do grupo de permissões é obrigatório"),
  descricao: yup.string().nullable().default(null),
});
